module.exports = __webpack_public_path__ + "static/media/border-line-type-white.2bdfdcbb.svg";